import React from "react";

import AboutPart from './AboutSection'
import Testimonial from './TestimonialSection'
import Feature from './FeatureSection'
import Instructor from './InstructorSection'
import WhoWeAre from "./WhoWeAre";
import OurGoal from "./OurGoal";
import OurMoments from "./OurMoments";

const AboutMain = ({data}) => {


    return (
        <>
            <AboutPart />
            <WhoWeAre data={data}/>
            <OurGoal/>
            <OurMoments/>
            
            {/* <Feature /> */}
            
            {/* <Instructor /> */}

            {/* <Testimonial /> */}
        </>
    )
}

export default AboutMain;